import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { handleResponseThrowError } from '@/_utils/services';
import { apiClient } from '@/_config/lib/axios/api-client';
import type { BaseRequestResponse } from '@/_types/services';
import type { FranchiseType } from '@/features/fare/types';

export const GET_CITY_FARE_BY_ID = 'GET_CITY_FARE_BY_ID';

const getCityFareById = (franchiseId: string) => {
  return apiClient
    .get<BaseRequestResponse<FranchiseType>>(`/municipios/${franchiseId}`)
    .then(response => response.data.data)
    .catch(handleResponseThrowError('Município não encontrado'));
};

type GetCityFareByIdResponseType = Awaited<ReturnType<typeof getCityFareById>>;

export const useGetCityFareById = (
  franchiseId: string,
  options?: Omit<
    UseQueryOptions<
      GetCityFareByIdResponseType,
      unknown,
      GetCityFareByIdResponseType,
      (string | string)[]
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery({
    queryKey: [GET_CITY_FARE_BY_ID, franchiseId],
    queryFn: () => getCityFareById(franchiseId),
    ...options,
  });
};
